import React from 'react';
import { useParams } from 'react-router-dom';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import { CLOSE_DIALOG_EVENT } from '@rio-cloud/rio-uikit/FrameDialog';
import usePostMessageSender from '@rio-cloud/rio-uikit/usePostMessageSender';

import Address from '@/features/common/components/Address';
import { DialogErrorState } from '@/features/common/components/dialogs/common/DialogErrorState';
import { DialogFooter } from '@/features/common/components/dialogs/common/DialogFooter';
import { DialogLoadingState } from '@/features/common/components/dialogs/common/DialogLoadingState';
import { MFE_DIALOG_PREFIX, WORKSHOPS_ENDPOINT_PATH } from '@/features/common/components/dialogs/dialogConstants';
import type { Workshop } from '@/generated/GeneratedApiTypes';
import { useGetDialogDataQuery } from '@/services/dialogsApi';

const WorkshopDetailsDialog: React.FC = () => {
    const { id: workshopId } = useParams<{ id: string }>();
    const { sendMessageToParent } = usePostMessageSender();

    const { data, isError, isLoading, refetch, isFetching } = useGetDialogDataQuery({
        path: WORKSHOPS_ENDPOINT_PATH,
        id: workshopId,
    });
    const workshop = data as Workshop;

    const handleCloseDialog = () => {
        sendMessageToParent({
            type: `${MFE_DIALOG_PREFIX}${CLOSE_DIALOG_EVENT}`,
            payload: `Closed workshop details dialog for ID: ${workshopId}`,
        });
    };

    if (isLoading || isFetching) {
        return <DialogLoadingState onClose={handleCloseDialog} />;
    }

    if (isError) {
        return <DialogErrorState onClose={handleCloseDialog} refetch={refetch} />;
    }
    const { workshop_address: workshopAddress } = workshop;
    return (
        <div className="bg-white min-height-200">
            <Dialog.Title title={workshop?.name} onCloseButtonClick={handleCloseDialog} />

            <Dialog.Body className={'padding-20'}>
                {workshop && (
                    <div>
                        <Address
                            street={workshopAddress?.street}
                            city={workshopAddress?.city}
                            zip={workshopAddress?.zip}
                            countryCode={workshopAddress?.country_code || ''}
                        />
                    </div>
                )}
            </Dialog.Body>

            <DialogFooter onClose={handleCloseDialog} />
        </div>
    );
};

export default WorkshopDetailsDialog;
